import {FormControl, Grid, IconButton, InputLabel, MenuItem, Select, Typography, withStyles} from '@material-ui/core'

import React, {Component} from 'react'
import {connect} from 'react-redux'
import CollectionCrud from '../../common/Components/CollectionCrud'
import {NumberInput, TextInput} from '@oniti/oniti-inputs';
import DossiersCss from './css/DossiersCss'
import { collectionActions } from '../../../reducers/collectionsReducer'
import { Payment, DoneAll, HelpOutline, MailOutline, LooksOne } from '@material-ui/icons';

class Dossiers extends Component {
  state = {
    selectedSejour: '',
    selectedStatut: '',
    paginationFilters: {},
  }

  collectionCrudRef = null;

  componentDidMount() {
    const { dispatch, sejoursStore } = this.props;
    if (!sejoursStore.list) {
      collectionActions(dispatch, 'sejours', 'INDEX');
    }
  }

  handleSejourChange = (event) => {
    this.setState({ selectedSejour: event.target.value }, () => {
      this.triggerReload();
    });
  }

  handleStatutChange = (event) => {
    this.setState({ selectedStatut: event.target.value }, () => {
      this.triggerReload();
    });
  }

  triggerReload() {
    if (this.collectionCrudRef) {
      this.collectionCrudRef.setDatatablePage(1);
    }

    this.loadAsyncData({
      ...this.state.paginationFilters,
      page: 1,
    });
  }

  getDateTime(string) {
    if (!string) {
      return ''
    }
    let date = new Date(string)
    let options = {day: 'numeric', month: 'numeric', year: 'numeric'}
    return date.toLocaleTimeString('fr-FR', options)
  }

  getDate(string) {
    if (!string) {
      return ''
    }
    let date = new Date(string)
    let options = {day: 'numeric', month: 'numeric', year: 'numeric'}
    return date.toLocaleDateString('fr-FR', options)
  }

  getCreateUpdateModalTitle(dossier) {
    if (!dossier) {
      return <>
        <Payment/>
        <span>chargement...</span>
      </>
    }

    return <>
      <Payment/>
      <span>Édition du dossier {dossier.parents_nom} {dossier.parents_prenom}</span>
    </>
  }

  getCreateUpdateModalContent(dossier, dossiersStore, onChangeHandler) {
    return (
      <Grid container>
        <Grid item xs={12}>
          <TextInput
            id="num_dossier_accoord"
            label="N° dossier"
            value={dossier.num_dossier_accoord}
            margin="normal"
            collectionStore={dossiersStore}
            name="num_dossier_accoord"
            onChangeHandler={onChangeHandler}
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
        <NumberInput
            id="reste_a_payer"
            label="Reste à payer"
            value={dossier.reste_a_payer}
            margin="normal"
            collectionStore={dossiersStore}
            name="reste_a_payer"
            onChangeHandler={onChangeHandler}
            fullWidth
            disabled={dossier.num_dossier_accoord ? false : true}
            helperText="Il est impératif de renseigner le numéro de dossier pour pouvoir saisir le reste à payer."
          />
        </Grid>
      </Grid>
    )
  }

  getStatus(dossier) {
    const slug = dossier.statut.split('-')[1]

    switch (slug) {
      case 'done':
        return <DoneAll titleAccess="terminé"/>
      case 'missing':
        return <HelpOutline titleAccess="numéro de dossier manquant"/>
      case 'mail':
        return <MailOutline titleAccess="attente réponse parent suite au mail"/>
      default:
    }
  }

  getPaiements(dossier) {
    const {classes} = this.props

    var amounts = [];
    dossier.paiements.forEach((paiement) => {
      amounts.push(paiement.amount_str)
    })

    const comp = amounts.join(' + ')

    return (
      <span title={comp} className={(amounts.length > 1) ? classes.details : ''}>
        {dossier.total_paiements_str}
      </span>
    )
  }

  getDossiersUrlsButton(dossier) {
    return (
      <React.Fragment key={"form-buttons-" + dossier.uuid}>
        <IconButton
          aria-label="lien de paiement parent"
          color="primary"
          title="lien de paiement parent"
          key={"form-dossier-" + dossier.uuid}
          disabled={dossier.statut.split('-')[1] !== 'mail'}
          onClick={() => window.open(dossier.url, '_blank')}
        >
          <LooksOne/>
        </IconButton>
      </React.Fragment>
    )
  }

  loadAsyncData(paginationFilters) {
    let { dispatch, dossiersStore } = this.props;

    if (dossiersStore.fetching) return;

    const { selectedSejour, selectedStatut } = this.state;

    if(paginationFilters) {
      // eslint-disable-next-line
      this.state.paginationFilters = paginationFilters;
    }

    var data_params = {};
    data_params.params = {
      ...this.state.paginationFilters,
      sejour_uuid: selectedSejour || null,
      statut: selectedStatut || null,
    };

    // Gardes fou pour éviter que des requêtes partent sans pagination
    if (!data_params.params.oniti_pagination) {
      data_params.params.oniti_pagination = 1;
    }
    if (!data_params.params.oniti_perpage) {
      data_params.params.oniti_perpage = 25;
    }

    return collectionActions(
      dispatch,
      "dossiers",
      "INDEX",
      data_params,
      null,
      true
    );
  }

  getSejoursOptions() {
    const { sejoursStore } = this.props;
    if (!sejoursStore.list) return [];
    return sejoursStore.list.map(sejour => (
      <MenuItem value={sejour.uuid} key={sejour.uuid}>
        {sejour.libelle}
      </MenuItem>
    ));
  }

  render() {
    const {classes} = this.props
    const {selectedSejour, selectedStatut} = this.state

    return (
      <Grid container spacing={2} className={classes.container}>
        <Typography
          variant="button"
          gutterBottom
          className={classes.sectionTitle}
        >
          Dossiers de paiement
        </Typography>

        <Grid container spacing={2} className={classes.filtersContainer}>
          <Grid item md={4}>
            <FormControl fullWidth>
              <InputLabel>Filtrer par séjour</InputLabel>
              <Select
                value={selectedSejour}
                onChange={this.handleSejourChange}
              >
                <MenuItem value="">Tous les séjours</MenuItem>
                {this.getSejoursOptions()}
              </Select>
            </FormControl>
          </Grid>
          <Grid item md={2}>
            <FormControl fullWidth>
              <InputLabel>Filtrer par statut</InputLabel>
              <Select
                value={selectedStatut}
                onChange={this.handleStatutChange}
              >
                <MenuItem value="">Tous les statuts</MenuItem>
                <MenuItem value="done">Terminé</MenuItem>
                <MenuItem value="missing">N° dossier manquant</MenuItem>
                <MenuItem value="mail">Attente réponse parent</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <CollectionCrud
          innerRef={(ref) => this.collectionCrudRef = ref}
          collectionName={'dossiers'}
          loadDatas={false}
          asynchrone={true}
          asynchroneCallbackLoadData={this.loadAsyncData.bind(this)}
          showBtnEdit={true}
          showBtnAdd={false}
          showBtnDelete={false}
          createUpdateModalTitle={this.getCreateUpdateModalTitle}
          createUpdateModalContent={this.getCreateUpdateModalContent.bind(this)}
          additionnalControllers={[
            this.getDossiersUrlsButton.bind(this),
          ]}
          datatableConfig={{
            showPagination: true,
            showSearch: true,
            rowsPerPageOptions: [20, 50, 100],
            defaultSort: "parents_nom",
            sortType: "desc",
            rowClassName: (row) => {
              const slug = row.statut.split('-')[1]

              switch(slug) {
                case 'done':
                  return classes.allDone
                case 'missing':
                  return classes.missingNumDoss
                case 'mail':
                  return classes.waitingParent
                default:
                  return ''
              }
            }
          }}
          cellsConfig={[
            {
              datakey: 'statut',
              title: 'Statut',
              sortable: false,
              searchable: false,
              format: this.getStatus,
            },
            {
              datakey: 'num_dossier_accoord',
              title: 'N° dossier',
              sortable: true,
              searchable: true,
            },
            {
              datakey: 'parents_nom',
              title: 'Nom parent',
              sortable: true,
              searchable: true,
            },
            {
              datakey: 'parents_prenom',
              title: 'Prénom parent',
              sortable: true,
              searchable: true,
            },
            {
              datakey: 'enfants',
              title: 'Enfant(s)',
              sortable: false,
              searchable: false,
              format: (obj, key) => {
                return '(' + obj[key].length + ') ' + obj[key].map((enfant) => {
                  return `${enfant.nom} ${enfant.prenom}`
                }).join(' / ')
              }
            },
            {
              datakey: 'sejours_arr',
              title: 'Séjours',
              sortable: false,
              searchable: false,
              format: (obj, key) => {
                return obj[key].map((sejour) => {
                  return `${sejour.libelle}`
                }).join(' / ')
              }
            },
            {
              datakey: 'total_paiements_str',
              title: 'Total réglé',
              sortable: false,
              searchable: true,
              className: classes.currency,
              format: this.getPaiements.bind(this),
            },
            {
              datakey: 'reste_a_payer_str',
              title: 'Reste à payer',
              sortable: false,
              searchable: true,
              className: classes.currency,
            },
          ]}
        />
      </Grid>
    );
  }
}

Dossiers = withStyles(DossiersCss)(Dossiers)

Dossiers = connect((store) => {
  return {
    dossiersStore: store.collections.dossiers,
    sejoursStore: store.collections.sejours,
  }
})(Dossiers);

export default Dossiers
